export default __webpack_public_path__ + "static/media/resume.acfe4874.pdf";